export default __webpack_public_path__ + "maps-guides-styles-layers-sky-layer-960-af8f386084b838b85ac62296eff58a02.webp";